import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Route guard that redirects unauthenticated users to the welcome screen.
 */
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) return <Navigate to="/auth" replace />;
    return children;
};

export default ProtectedRoute;
